import { Reducer } from 'redux';
import { MachineDefect } from "models/MachineDefect";
import { IMachineDefectActions, MachineDefectActionType } from "redux/actions/machines/MachineDefectActions";

const initialState: MachineDefect[] | null = null;
export const machineDefectsReducer: Reducer<MachineDefect[] | null, IMachineDefectActions> =
    (state = initialState, action) => {
        switch (action.type) {
            case MachineDefectActionType.FETCH_MACHINEDEFECTS_SUCCESS:
                {
                    return action.returnPayload as MachineDefect[];
                }
            case MachineDefectActionType.ADD_MACHINEDEFECT_SUCCESS:
                {
                    if (!state) return state; // defects not fetched yet, SignalR updates still arrive
                    let newMachineDefects = [...state!];
                    newMachineDefects.push({ ...action.returnPayload } as MachineDefect)
                    return newMachineDefects;
                }
            case MachineDefectActionType.EDIT_MACHINEDEFECT_SUCCESS:
            case MachineDefectActionType.DELETE_MACHINEDEFECT_SUCCESS:
                {
                    if (!state) return state;
                    let newMachineDefects = [...state!];
                    const updatedMachineDefect = { ...action.returnPayload } as MachineDefect;
                    newMachineDefects = newMachineDefects.map(nm => nm.id === updatedMachineDefect.id ? updatedMachineDefect : nm);
                    return newMachineDefects;
                }
            default:
                return state;
        }
    };
